module.exports = "../images/testimonials-bg-cabin@2x.jpg?v=28752ae";